import React from "react";

import { UIProps } from "components/base/types";
import Box from "ui-box";

export const Image = (props: UIProps) => <Box is="img" {...props} />;

export default Image;
